import { ExportStatus } from "../../main/constants/export.constants";

export default class SegmentShowCtrl {
    constructor($scope, $rootScope, $window, $state, SweetAlert, $filter, $timeout, $stateParams, $location, Rest, SideMenu, Segment, FacebookService, Facebook, Events, Customization) {
        SideMenu.setActive('tag');

        this._scope = $scope;
        this._rootScope = $rootScope;
        this._window = $window;
        this._state = $state;
        this._filter = $filter;
        this._timeout = $timeout;
        this._stateParams = $stateParams;
        this._translator = $filter('translate');

        this.sweetAlert = SweetAlert;
        this.rest = Rest.rest;
        this.eventHandler = Events;
        this.segmentRepo = Segment;
        this.location = $location;

        this.fb = FacebookService;
        this.fbRepo = Facebook;
        this.fb.init();

        this.customizationRepo = Customization;

        this.progressListenerId = null;

        this.repositoryAttributes = {
            segmentId: this._stateParams.id
        };

        this.selections = {
            sumOperators: [
                {value: 'eq', text: this._filter('translate')('SEGMENTATION:SELECTION:EQ')},
                {value: 'ne', text: this._filter('translate')('SEGMENTATION:SELECTION:NE')},
                {value: 'gte', text: this._filter('translate')('SEGMENTATION:SELECTION:GTE')},
                {value: 'lte', text: this._filter('translate')('SEGMENTATION:SELECTION:LTE')}
            ]
        };

        this.campaigns = [];
        this.automations = [];
        this.journeys = [];

        this.showInfo = true;
        this.numSubscribers = 0;
        this.isLoading = true;
        this.isSyncing = false;
        this.syncEditable = false;
        this.syncAtEnabled = false;
        this.deleteSubscribersEnabled = false;
        this.showDeleteAlert = false;
        this.settings = {};
        this.subscriberCount = {};
        this.subscriberCountShow = false;
        this.originalName = '';
        this.groupSettings = [];
        this.customization = {
            groups: []
        };
        this.groups = [];

        this.mergedRulesList = [];

        this.loadedTags = false;

        this.clearRules = {
            groups: {
                key: 'and',
                remove: false
            }
        };

        this.googleAccountData = null;
        this.showGoogleButton = false;
        this.googleSincInProgress = false;
        this.googleButtonLabel = 'SEGMENT:GOOGLE_BUTTON:LOGIN';

        this.getCampaignList().then(campaigns => {
            this.campaigns = campaigns.data;
        });

        this.getAutomationList().then(automations => {
            this.automations = automations.data;
        });

        this.getJourneysList().then(journeys => {
            this.journeys = journeys.data;
        });

        this.countSubscribers();

        this.subscriberGroups = [
            {
                groupName: this._filter('translate')('SEGMENTATION:SHOW:STANDARD_FIELDS_NAME'),
                basedOn: 'standard_field',
                fieldName: this._filter('translate')('GLOBAL:EMAIL'),
                fieldId: 'email',
                fieldType: 'email',
                fieldValues: null
            },
            {
                groupName: this._filter('translate')('SEGMENTATION:SHOW:STANDARD_FIELDS_NAME'),
                basedOn: 'standard_field',
                fieldName: this._filter('translate')('GLOBAL:PHONE_NUMBER'),
                fieldId: 'phone_number',
                fieldType: 'phone_number',
                fieldValues: null
            },
            {
                groupName: this._filter('translate')('SEGMENTATION:SHOW:STANDARD_FIELDS_NAME'),
                basedOn: 'standard_field',
                fieldName: this._filter('translate')('GLOBAL:LANGUAGE'),
                fieldId: 'language',
                fieldType: 'language',
                fieldValues: null
            },
            {
                groupName: this._filter('translate')('SEGMENTATION:SHOW:STANDARD_FIELDS_NAME'),
                basedOn: 'standard_field',
                fieldName: this._filter('translate')('GLOBAL:ACTIVITY'),
                fieldId: 'activity',
                fieldType: 'date',
                fieldValues: null
            },
            {
                groupName: this._filter('translate')('SEGMENTATION:SHOW:STANDARD_FIELDS_NAME'),
                basedOn: 'standard_field',
                fieldName: this._filter('translate')('GLOBAL:CREATED_AT'),
                fieldId: 'created_at',
                fieldType: 'date',
                fieldValues: null
            },
            {
                id: "suppression",
                groupName: this._filter('translate')('SUBSCRIBER:IMPORT:SUPPRESSION'),
                name: this._filter('translate')('SUBSCRIBER:IMPORT:SUPPRESSION'),
                basedOn: 'suppression',
                fieldId: "suppression",
                fieldType: 'suppression',
            }
        ];

        this.customizationRepo.allGroups().then((groups) => {
            this.customization.groups = this.rest.stripRestangular(groups.data);
            this.groups = [];
            _.each(this.customization.groups, (group) => {
                _.each(group.fields, (field) => {
                    this.groups.push({
                        groupName: group.name,
                        basedOn: 'custom_field',
                        groupId: group.id,
                        fieldName: field.name,
                        fieldId: field.id,
                        fieldType: field.type,
                        fieldValues: field.custom_field_options
                    });
                });
            });

            this.operatorGroups = this.groups;
            this.segmentRepo.find(this._stateParams.id).then((segment) => {
                this.syncEditable = segment.meta.sync_editable;

                if (segment.data.sync_at) {
                    this.syncAtEnabled = true;
                    let syncDate = new Date();
                    syncDate.setHours(segment.data.sync_at.split(':')[0]);
                    syncDate.setMinutes(segment.data.sync_at.split(':')[1]);
                    segment.data.sync_at = syncDate;
                }

                this.segment = segment.data;
                this.originalName = angular.copy(this.segment.name);
                this.segment.tags = this.segment.tags ? this.segment.tags.data : [];
                this.loadedTags = this.segment.tags;
                if (!segment.data.structure.length) {
                    this.rules = this.clearRules;
                } else {
                    this.rules = JSON.parse(segment.data.structure).rules;

                    if (this.rules.groups.rules && this.rules.groups.rules.length > 0) {
                        this.rules.groups.rules = this.getFormattedRules(this.rules.groups.rules);
                    }

                    if (this.rules.groups.statistic_rules && this.rules.groups.statistic_rules.length > 0) {
                        this.rules.groups.statistic_rules = this.getFormattedStatisticRules(this.rules.groups.statistic_rules);
                    }

                    if (this.rules.groups.hasOwnProperty('segments')) {
                        this.loadedSegments = this.rules.groups.segments;
                    }
                }

                this.mergedRulesList = this.getMergedRulesList();
                if (this._state.params.isNew) {
                    setTimeout(() => {
                        this.mergedRulesList.push({
                            field: 'language',
                            rule_type: 'standard_rule',
                            operator: null,
                            value: [],
                            autofocus: true
                        });
                    });
                }

                this.isLoading = false;
                this.deleteSubscribersEnabled = segment.data.subscriber_delete;
                this.showDeleteAlert = segment.data.subscriber_delete;
                this.listenToSyncProgress();

                switch (this.location.search().google_auth_success) {
                    case '0': {
                        if (this.location.search().google_auth_error) {
                            this.eventHandler.flashEvent('error', this.location.search().google_auth_error);
                        } else {
                            this.eventHandler.flashEvent('error', this._filter('translate')('SEGMENTATION:SHOW:GOOGLE_AUTH_FAILED'));
                        }
                    }
                        break;
                    case '1':
                        this.onUploadWithGoogleClick();
                        break;
                }

                switch (this.location.search().facebook_auth_success) {
                    case '0': {
                        if (this.location.search().facebook_auth_error) {
                            this.eventHandler.flashEvent('error', this.location.search().facebook_auth_error);
                        } else {
                            this.eventHandler.flashEvent('error', this._filter('translate')('SEGMENTATION:SHOW:FACEBOOK_AUTH_FAILED'));
                        }
                    }
                        break;
                    case '1':
                        this.loginAndUploadSubscribers();
                        break;
                }
            })
        });

        this._scope.$watch('rules.groups', (newVal, oldVal) => {
            if (!newVal) {
                return;
            }
            if (newVal && newVal.hasOwnProperty('remove')) {
                this.rules.groups = false;
            }
        });

        // Check whether an export is running or has been finished.
        this._timeout(() => {
            this.segmentRepo.getExportById(this._stateParams.exportId).then((progress) => {
                if (Array.isArray(progress.data)) {
                    progress.data.forEach((progress) => {
                        this.exportProgressHandler(progress?.status?.value);
                    });
                } else {
                    this.exportProgressHandler(progress.data?.status?.value);
                }
            }).catch((error) => {
                console.error(error);
                this.exportActive = false;
                this.eventHandler.flashEvent('error', this._translator('NOTIFICATION:TYPE:EXPORT_FAILED_HEADER'));
            });
        }, 2000);

        this._rootScope.$on('segment:export:completed', (event, url) => {
            this.exportActive = false;
            this.exportFileUrl = url;
        });

        this._rootScope.$on('account:changed', () => {
            this._state.go('filter.index');
        });

        this._scope.$on('$destroy', () => {
            this.stopListenToProgress();
        });

        this._scope.$on('segment:uploadSubscribersToFb', (event, result) => {
            this.uploadSubscribersToFb(result.accountId, result.accountName);
        });

        this._scope.$on('segment:uploadSubscribersToGoogle', (event, account_id) => {
            this.uploadSubscribersToGoogle(account_id);
        });
    }

    exportProgressHandler(statusValue) {
        if (statusValue === ExportStatus.Finished) {
            this.segmentRepo.getExportDownloadLink(this._stateParams.exportId).then((download) => {
                this.exportFileUrl = download.data.url;
            })
            this.exportActive = false;
        } else {
            this.exportActive = true;
            this._rootScope.$emit('progress:start', 'segment-export');
        }
    }

    inputTypes(fieldType) {
        switch (fieldType) {
            case 'multiple':
                return 'multiple';
                break;
            default:
                return 'text';
        }
    };

    toggleShowInfo() {
        this.showInfo = !this.showInfo;
    };

    getFieldFromId(id) {
        let index = _.findIndex(this.groups, {fieldId: id});
        if (index > -1) {
            return this.groups[index]
        }
    };

    getFormattedRules(rules) {
        rules.forEach(rule => {
            if (rule.field && typeof rule.field === 'string') rule.field = parseInt(rule.field);
        });
        return rules;
    }

    getFormattedStatisticRules(rules) {
        rules.forEach(rule => {
            if (rule.value && !rule.value.dispatcher && rule.value.last_dispatchers_count) {
                if (rule.value.last_dispatchers_count === 1) {
                    rule.value.dispatcher = this._filter('translate')('SEGMENTATION:LAST_CAMPAIGN');
                } else {
                    rule.value.dispatcher = this._filter('translate')('SEGMENTATION:LAST_X_CAMPAIGNS').replace('?', rule.value.last_dispatchers_count);
                }
            }
            if (rule.value && !rule.value.dispatcher && !rule.value.last_dispatchers_count) {
                rule.value.dispatcher = this._filter('translate')('SEGMENTATION:ALL_CAMPAIGNS');
            }
        });
        return rules;
    }

    getMergedRulesList() {
        let rules = this.rules.groups.rules ? this.rules.groups.rules : [];
        rules.forEach(rule => rule.rule_type = 'custom_rule');
        let subscriber_rules = this.rules.groups.subscriber_rules ? this.rules.groups.subscriber_rules : [];
        subscriber_rules.forEach(rule => rule.rule_type = 'standard_rule');
        let statistic_rules = this.rules.groups.statistic_rules ? this.rules.groups.statistic_rules : [];
        statistic_rules.forEach(rule => rule.rule_type = 'statistic_rule');
        let suppression_rules = this.rules.groups.suppression_rules ? this.rules.groups.suppression_rules : [];
        return [].concat(rules, subscriber_rules, statistic_rules, suppression_rules);
    }

    getGroupedRulesLists() {
        let rules = this.mergedRulesList.filter(rule => rule.rule_type === 'custom_rule');
        let subscriber_rules = this.mergedRulesList.filter(rule => rule.rule_type === 'standard_rule');
        let statistic_rules = this.mergedRulesList.filter(rule => rule.rule_type === 'statistic_rule');
        let suppression_rules = this.mergedRulesList.filter(rule => rule.rule_type === 'suppression_rule');

        return angular.copy({
            rules, subscriber_rules, statistic_rules, suppression_rules
        });
    }

    saveRules() {
        this.update(true);
    };

    newRule() {
        this.mergedRulesList.push({field: null, rule_type: 'standard_rule', operator: null, value: ''});
    };

    enableHistoricalData() {
        this.rules.historical = true;
    };

    disableHistoricalData() {
        this.rules.historical = false;

        this.rules.counts = [];
        this.rules.sums = [];
        this.rules.avgs = [];
        this.rules.aggregateConstraints = this.initAggregateConstraints();
    };

    newCount() {
        if (!this.rules.hasOwnProperty('counts')) {
            this.rules.counts = [];
        }

        if (this.rules.counts.length < 1) {
            if (this.groups.length) {
                this.rules.counts.push({group: this.groups[0].groupId, operator: 'eq', value: ''});
            }
        } else {
            this.eventHandler.flashEvent('error', this._filter('translate')('SEGMENTATION:SHOW:MAX_COUNTS_FLASH'))
        }
    };

    newSum() {
        if (!this.rules.hasOwnProperty('sums')) {
            this.rules.sums = [];
        }
        this.rules.sums.push({field: null, operator: 'eq', value: ''});
    };

    newAvg() {
        if (!this.rules.hasOwnProperty('avgs')) {
            this.rules.avgs = [];
        }
        this.rules.avgs.push({field: null, operator: 'eq', value: ''});
    };

    newAggregateConstraintsRule(type) {
        let aggregateConstraints = this.rules.aggregateConstraints;
        if (!aggregateConstraints) {
            aggregateConstraints = this.initAggregateConstraints();
        }
        if (!aggregateConstraints[type]) {
            aggregateConstraints[type] = {
                key: 'and',
                rules: []
            };
        }
        aggregateConstraints[type].rules.push({field: null, operator: null, value: ''});
        this.rules.aggregateConstraints = aggregateConstraints;
    };

    removeSum(index) {
        if (this.rules.aggregateConstraints && this.rules.aggregateConstraints.sum) {
            this.rules.aggregateConstraints.sum.rules = [];
        }

        this.rules.sums.splice(index, 1);
    };

    removeAvg(index) {
        if (this.rules.aggregateConstraints && this.rules.aggregateConstraints.avg) {
            this.rules.aggregateConstraints.avg.rules = [];
        }

        this.rules.avgs.splice(index, 1);
    };

    getGroupLevel(group) {
        return this.findGroupKeys(this.rules, group, []).length - 1
    };

    isCombined() {
        if (this.rules && this.rules.hasOwnProperty('groups')) {
            return this.rules.groups.hasOwnProperty('segments');
        }
        return false
    };

    findGroupKeys(groups, toFind, keyLevel) {
        for (var i in groups) {
            if (toFind == groups[i]) {
                keyLevel.push(i);
                return keyLevel
            }
        }

        for (var i in groups) {
            if (groups[i].groups) {
                keyLevel.push(i);
                if (this.findGroupKeys(groups[i].groups, toFind, keyLevel)) {
                    return keyLevel
                }
            }
        }

        return false
    };

    update(shouldSyncFilter) {
        if (!this.segment.tags.length) {
            return this.sweetAlert.swal({
                title: this._filter('translate')('GLOBAL:FLASH:OOPS'),
                text: this._filter('translate')('SEGMENTATION:FLASH:TAG_ERROR'),
                type: "error"
            });
        }

        if (!this.segment.name.length) {
            this.segment.name = this.originalName;
            return this.eventHandler.flashEvent('error', this._filter('translate')('SEGMENTATION:FLASH:EMPTY_NAME'));
        }

        let rules = angular.copy(this.rules);

        let rulesGroups = this.getGroupedRulesLists();

        rules.groups.rules = rulesGroups.rules;
        rules.groups.subscriber_rules = rulesGroups.subscriber_rules;
        rules.groups.suppression_rules = rulesGroups.suppression_rules;
        rules.groups.statistic_rules = rulesGroups.statistic_rules;


        let strRules = JSON.stringify(rules);
        let statistic_rules = rules.groups.statistic_rules;

        if (statistic_rules && statistic_rules.length) {
            for (let ruleIndex = 0; ruleIndex < statistic_rules.length; ruleIndex++) {
                let rule = statistic_rules[ruleIndex];
                if (!this.isIntegerAndPositive(rule.statistic_type) || !rule.operator || !rule.value) {
                    return this.throwActivityRuleValidationError();
                }
                if (rule.value) {
                    if (!rule.value.dispatcher_type) return this.throwActivityRuleValidationError();
                    if (this.isIntegerAndPositive(rule.value.days_limit) && rule.value.days_limit > 450) {
                        return this.throwActivityRuleValidationError(true);
                    }
                }

                rule.value['dispatcher'] = rule.value.dispatcher ? rule.value.dispatcher : null;
                rule.value['last_dispatchers_count'] = rule.value.last_dispatchers_count ? rule.value.last_dispatchers_count : null;

                if (rule.value.last_dispatchers_count >= 1 || typeof rule.value.dispatcher === "string") {
                    rule.value.dispatcher = null;
                }

                rule.value['link'] = rule.value.link ? rule.value.link : null;
            }
        }

        if (strRules.indexOf('"operator":null') !== -1) {
            return this.sweetAlert.swal({
                title: this._filter('translate')('GLOBAL:FLASH:OOPS'),
                text: this._filter('translate')('SEGMENTATION:FLASH:OPERATOR_ERROR'),
                type: 'error'
            });
        }

        for (let groupKey in rulesGroups) {
            const rules = rulesGroups[groupKey];
            for (let ruleIndex = 0; ruleIndex < rules.length; ruleIndex++) {
                const rule = rules[ruleIndex];
                if (!this.isValidRule(rule)) {
                    return this.sweetAlert.swal({
                        title: this._filter('translate')('GLOBAL:FLASH:OOPS'),
                        text: this._filter('translate')('SEGMENTATION:FLASH:EMPTY_VALUE_ERROR'),
                        type: 'error'
                    });
                }
            }
        }

        if (this.rules.historical) {
            if (!this.historicalRulesHaveCustomFields(this.rules)) {
                return this.sweetAlert.swal({
                    title: this._filter('translate')('GLOBAL:FLASH:OOPS'),
                    text: this._filter('translate')('SEGMENTATION:FLASH:EMPTY_FIELD_ERROR'),
                    type: 'error'
                });
            }

            if (!this.historicalRulesHaveValues(this.rules)) {
                return this.sweetAlert.swal({
                    title: this._filter('translate')('GLOBAL:FLASH:OOPS'),
                    text: this._filter('translate')('SEGMENTATION:FLASH:EMPTY_VALUE_ERROR'),
                    type: 'error'
                });
            }

            if (this.rules.aggregateConstraints) {
                if (this.rules.counts && this.rules.counts.length && !this.isValidConstraints(this.rules.aggregateConstraints, 'count')) {
                    return;
                }
                if (this.rules.sums && this.rules.sums.length && !this.isValidConstraints(this.rules.aggregateConstraints, 'sum')) {
                    return;
                }
                if (this.rules.avgs && this.rules.avgs.length && !this.isValidConstraints(this.rules.aggregateConstraints, 'avg')) {
                    return;
                }
            }
        }

        this.segment.structure = {rules};

        let segment = angular.copy(this.segment);
        let syncTime = segment.sync_at ? new Date(segment.sync_at) : null;
        segment.sync_at = syncTime && this.syncAtEnabled ? {
            hour: syncTime.getHours(),
            minutes: syncTime.getMinutes()
        } : null;
        segment.deleteSubscribersEnabled = this.deleteSubscribersEnabled;

        if (shouldSyncFilter) {
            this.isSyncing = true;
        }

        return this.segmentRepo.update(segment, true, false, shouldSyncFilter).then((response) => {
            this.originalName = this.segment.name;
            this.eventHandler.flashEvent('notification', this._filter('translate')('SEGMENTATION:FLASH:SAVE'));
            this.segment.updated_at = response.segment.updated_at;
            if (shouldSyncFilter) {
                this.listenToSyncProgress();
            }
        }, (e) => {
            this.isSyncing = false;
            if (e.status === 400) {
                this.sweetAlert.swal({
                    title: this._filter('translate')('GLOBAL:FLASH:OOPS'),
                    text: this._filter('translate')('SEGMENTATION:FLASH:TAG_ERROR'),
                    type: "error"
                })
            } else {
                this.sweetAlert.swal({
                    title: this._filter('translate')('GLOBAL:FLASH:OOPS'),
                    text: this._filter('translate')('SEGMENTATION:FLASH:UNEXPECTED_ERROR'),
                    type: 'error'
                })
            }
        })
    };

    countSubscribers() {
        this.segmentRepo.subscriberCount(this._stateParams.id)
            .then(result => {
                let active = result.subscriberCount.active;
                let byTypes = result.subscriberCount.byTypes || {};
                byTypes = Object.keys(byTypes).map((key) => {
                    return {name: key, count: byTypes[key]};
                });
                this.subscriberCount = {active, byTypes}
            });
    };

    listenToSyncProgress() {
        this.isSyncing = true;
        this.stopListenToProgress();
        this.progressListenerId = this._timeout(() => {
            this.segmentRepo.countProgress(this.segment.id).then(progress => {
                if (progress === "Fetching") {
                    return this.listenToSyncProgress();
                }

                this.isSyncing = false;
                this.countSubscribers();
                this.stopListenToProgress();
                this._scope.$broadcast('subscriberGrid:reload');
            }, error => {
                this.isSyncing = false;
                this.stopListenToProgress();
                this.sweetAlert.swal({
                    title: this._filter('translate')('GLOBAL:FLASH:OOPS'),
                    text: this._filter('translate')('SEGMENTATION:FLASH:SYNC_FAILED'),
                    type: "error"
                });
            });
        }, 4000);
    }

    stopListenToProgress() {
        this._timeout.cancel(this.progressListenerId);
    }

    isValidRule(rule) {
        if (rule.rule_type === 'statistic_rule'
            || rule.operator === 'is_empty'
            || rule.operator === 'is_not_empty'
            || rule.operator === 'yearly'
            || rule.value instanceof Date) {
            return true;
        }
        if (Number.isInteger(rule.value)) {
            return true;
        }
        return !(!rule.value || !rule.value.length);
    }

    historicalRulesHaveValues(rules) {
        if (rules.counts && rules.counts.length > 0 && !this.allSubRulesHaveValues(rules.counts)) {
            return false
        }

        if (rules.sums && rules.sums.length > 0 && !this.allSubRulesHaveValues(rules.sums)) {
            return false
        }

        if (rules.avgs && rules.avgs.length > 0 && !this.allSubRulesHaveValues(rules.avgs)) {
            return false
        }

        return true;
    }

    allSubRulesHaveValues(historicalRulesGroup) {
        return historicalRulesGroup.every((rule) => this.isValidRule(rule));
    }

    historicalRulesHaveCustomFields(rules) {
        if (rules.counts && rules.counts.length > 0 && !this.allSubRulesHaveCustomFields(rules.counts, 'group')) {
            return false;
        }

        if (rules.sums && rules.sums.length > 0 && !this.allSubRulesHaveCustomFields(rules.sums)) {
            return false;
        }

        if (rules.avgs && rules.avgs.length > 0 && !this.allSubRulesHaveCustomFields(rules.avgs)) {
            return false;
        }

        return true;
    }

    allSubRulesHaveCustomFields(historicalRulesGroup, fieldToCheck = 'field') {
        return historicalRulesGroup.every((rule) => rule[fieldToCheck] !== null);
    }

    isValidConstraints(constraints, type) {
        if (constraints[type] && constraints[type].rules.length) {
            for (let rule of constraints[type].rules) {
                if (!this.isValidRule(rule)) {
                    this.sweetAlert.swal({
                        title: this._filter('translate')('GLOBAL:FLASH:OOPS'),
                        text: this._filter('translate')('SEGMENTATION:FLASH:EMPTY_VALUE_ERROR'),
                        type: 'error'
                    });
                    return false;
                }
            }
        }
        return true;
    }

    delete() {
        this.sweetAlert.swal({
                title: this._filter('translate')('GLOBAL:FLASH:DELETE'),
                text: this._filter('translate')('SEGMENTATION_MODAL:DELETE:DELETE_EXPLAINED'),
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: this._filter('translate')('GLOBAL:YES'),
                cancelButtonText: this._filter('translate')('GLOBAL:NO')
            }, (isConfirm) => {
                if (isConfirm) {
                    this.segmentRepo.destroy(this._stateParams.id).then(() => {
                        this._state.go('filter.index');
                        this.eventHandler.flashEvent('notification', this._filter('translate')('SEGMENTATION:FLASH:DELETE'));
                    }, (message) => {
                        let errorText = message.status === 409 ? this._filter('translate')('FILTER:FLASH:DELETE_ERROR')
                                .replace(
                                    /:automails/,
                                    message.data.data
                                        .map(item => item.name ? item.name : '[No name]')
                                        .join("\n")
                                ) :
                            this._filter('translate')('GLOBAL:FLASH:DELETE_ERROR');

                        this.sweetAlert.swal({
                            title: this._filter('translate')('GLOBAL:FLASH:OOPS'),
                            text: errorText,
                            type: "error"
                        });
                    })
                }
            }
        )
    };

    deleteSubscribers() {
        this.sweetAlert.swal({
                title: this._filter('translate')('GLOBAL:FLASH:DELETE'),
                text: this._filter('translate')('SEGMENTATION_MODAL:DELETE_SUBSCRIBERS:DELETE_EXPLAINED'),
                type: 'warning',
                customClass: 'sweet-alert--delete',
                showCancelButton: true,
                confirmButtonText: this._filter('translate')('GLOBAL:YES'),
                cancelButtonText: this._filter('translate')('GLOBAL:NO')
            }, (isConfirm) => {
                if (isConfirm) {
                    this.segmentRepo.deleteSubscribers(this._stateParams.id).then(() => {
                        this._state.go(this._state.current, {isNew: false}, {reload: true});
                        this.eventHandler.flashEvent('notification', this._filter('translate')('SEGMENTATION:FLASH:DELETE_SUBSCRIBERS'));
                    }, () => {
                        this.sweetAlert.swal({
                            title: this._filter('translate')('GLOBAL:FLASH:OOPS'),
                            text: this._filter('translate')('GLOBAL:FLASH:DELETE_ERROR'),
                            type: "error"
                        });
                    })
                }
            }
        )
    }

    copy() {
        this.update(false).then(() => {
            this.segmentRepo.copy(this.segment.id).then((newSegment) => {
                this._state.go('filter.show', {id: newSegment.data.id, isNew: false});
                this.eventHandler.flashEvent('notification', this._filter('translate')('SEGMENTATION:FLASH:COPY'))
            })
        });
    }

    toExport() {
        this._state.go('filter.export', {id: this._stateParams.id});
    };

    downloadExport() {
        this._window.open(this.exportFileUrl);
    };

    getAutomationList() {
        return this.segmentRepo.getDispatchers('automation');
    }

    getJourneysList() {
        return this.segmentRepo.getDispatchers('journey');
    }

    getCampaignList() {
        return this.segmentRepo.getDispatchers('campaign');
    }

    throwActivityRuleValidationError(daysLimitExcessError) {
        if (daysLimitExcessError) {
            return this.sweetAlert.swal({
                title: this._filter('translate')('GLOBAL:FLASH:OOPS'),
                text: this._filter('translate')('SEGMENTATION:FLASH:DAYS_LIMIT_ERROR'),
                type: 'error'
            });
        }
        this.sweetAlert.swal({
            title: this._filter('translate')('GLOBAL:FLASH:OOPS'),
            text: this._filter('translate')('SEGMENTATION:FLASH:EMPTY_FIELDS_ERROR'),
            type: 'error'
        });
    }

    isIntegerAndPositive(val) {
        return Number.isInteger(val) && val >= 0;
    }

    enableDeleteSubscribers() {
        if (this.syncAtEnabled && this.deleteSubscribersEnabled) {
            this.sweetAlert.swal({
                title: this._filter('translate')('SEGMENTATION_MODAL:ENABLE_DELETE'),
                text: this._filter('translate')('SEGMENTATION_MODAL:ENABLE_DELETE:ENABLE_EXPLAINED'),
                type: 'warning',
                customClass: 'sweet-alert--delete',
                showCancelButton: true,
                confirmButtonText: this._filter('translate')('GLOBAL:YES'),
                cancelButtonText: this._filter('translate')('GLOBAL:NO')
            }, (isConfirm) => {
                if (!isConfirm) {
                    this.deleteSubscribersEnabled = false;
                }
            })
        } else if (!this.syncAtEnabled && this.deleteSubscribersEnabled) {
            this.eventHandler.flashEvent('error', this._filter('translate')('SEGMENTATION:FLASH:INACTIVE_SYNC_AT_ERROR'))
            this.deleteSubscribersEnabled = false;
        }
    }

    toggleSyncAt() {
        if (!this.syncAtEnabled) {
            this.deleteSubscribersEnabled = false;
        }
    }

    initAggregateConstraints() {
        return {
            count: {
                key: 'and',
                rules: []
            },
            sum: {
                key: 'and',
                rules: []
            },
            avg: {
                key: 'and',
                rules: []
            },
        }
    }

    onUploadWithGoogleClick() {
        if (this.showGoogleButton) {
            this.showGoogleButton = false;
        } else {
            this.googleSincInProgress = true;
            this.fbRepo.checkGoogleAccount()
                .then((result) => {
                    this.googleAccountData = result.data;

                    if (this.googleAccountData) {
                        this.uploadFilterToGoogleAudience();
                    }
                })
                .catch((error) => {
                    this.showGoogleButton = true;
                    this.googleButtonLabel = 'SEGMENT:GOOGLE_BUTTON:LOGIN';
                });
        }
    }

    uploadFilterToGoogleAudience() {
        this.googleSincInProgress = true;
        if (this.googleAccountData) {
            this.fbRepo.getGoogleAdAccounts(this.googleAccountData.id)
                .then((result) => {
                    if (result.data) {
                        const accounts = result.data.map(
                            (account) => ({id: account.id, name: `${account.customer_name} (${account.customer_id})`})
                        );
                        if (accounts.length) {
                            this.openGoogleAccountsPicker(accounts);
                        } else {
                            this.eventHandler.flashEvent('error', this._filter('translate')('SEGMENTATION:SHOW:NO_ACCOUNTS_FOUND'));
                        }
                    }
                    this.googleSincInProgress = false;
                })
                .catch((error) => {
                    this.eventHandler.flashEvent('error', this._filter('translate')('SEGMENTATION:SHOW:UNABLE_TO_FETCH_CUSTOMERS'));
                });
        } else {
            this.fbRepo.getGoogleAuthUrl(window.location.href).then((result) => {
                if (result.url) {
                   window.location.href = result.url;
                }

                this.googleSincInProgress = false;
            });
        }
    }

    loginAndUploadSubscribers() {
        this.fbRepo.getAdAccounts(this.segment.id)
            .then((result) => {
                const accounts = result.data;

                const businessAccounts = accounts
                    .filter((account) => !!account.business)
                    .map((account) => ({id: account.id, name: `${account.name} (${account.id})`}));

                if (businessAccounts.length) {
                    if (businessAccounts.length > 1) {
                        this.openFbAccountsPicker(businessAccounts);
                    } else {
                        this.uploadSubscribersToFb(businessAccounts[0].id, businessAccounts[0].name);
                    }
                } else {
                    this.eventHandler.flashEvent('error', this._filter('translate')('SEGMENTATION:SHOW:NO_ACCOUNTS_FOUND'));
                }
            })
            .catch((error) => {
                this.fbRepo.getFacebookAuthUrl(this.segment.id, window.location.href).then((result) => {
                    if (result.url) {
                        window.location.href = result.url;
                    }
                });
            });
    };

    uploadSubscribersToFb(customerId, customerName) {
        this.fbRepo.uploadSubscribers(customerId, customerName, this.segment.id)
            .then((result) => {
                    if (result.success) {
                        this.facebookAudienceCreated();
                    } else if (result.error) {
                        this.facebookAudienceUpdate();
                    }
                }
            );
    }

    uploadSubscribersToGoogle(account_id) {
        this.fbRepo.uploadGoogleSubscribers(this.googleAccountData.id, account_id, this.segment.id)
            .then((result) => {
                if (result.success) {
                    this.googleAudienceCreated();
                }
            });
    }

    openGoogleAccountsPicker(accounts) {
        this._scope.$broadcast('segment:show:selectGoogleAccount', accounts);
    }

    openFbAccountsPicker(accounts) {
        this._scope.$broadcast('segment:show:selectFbAccount', accounts);
    }

    facebookAudienceCreated() {
        this.sweetAlert.swal({
                title: this._filter('translate')('SEGMENTATION:FACEBOOK:AUDIENCE:TITLE'),
                text: this._filter('translate')('SEGMENTATION:FACEBOOK:AUDIENCE:CREATE'),
                type: "success",
                showCancelButton: false,
                confirmButtonText: this._filter('translate')('GLOBAL:OK'),
            }
        )
    }

    facebookAudienceUpdate() {
        this.sweetAlert.swal({
                title: this._filter('translate')('SEGMENTATION:FACEBOOK:AUDIENCE:UPDATE:TITLE'),
                text: this._filter('translate')('SEGMENTATION:FACEBOOK:AUDIENCE:UPDATE'),
                type: "warning",
                customClass: 'sweet-alert--delete',
                showCancelButton: false,
                confirmButtonText: this._filter('translate')('GLOBAL:OK'),
            }
        )
    }

    googleAudienceCreated() {
        this.sweetAlert.swal({
                title: this._filter('translate')('SEGMENTATION:GOOGLE:AUDIENCE:TITLE'),
                text: this._filter('translate')('SEGMENTATION:GOOGLE:AUDIENCE:CREATE'),
                type: "success",
                showCancelButton: false,
                confirmButtonText: this._filter('translate')('GLOBAL:OK'),
            }
        )
    }

    googleAudienceUpdate() {
        this.sweetAlert.swal({
                title: this._filter('translate')('SEGMENTATION:GOOGLE:AUDIENCE:UPDATE:TITLE'),
                text: this._filter('translate')('SEGMENTATION:GOOGLE:AUDIENCE:UPDATE'),
                type: "warning",
                customClass: 'sweet-alert--delete',
                showCancelButton: false,
                confirmButtonText: this._filter('translate')('GLOBAL:OK'),
            }
        )
    }
}
